import React,{ useContext} from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { alpha, useTheme } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import logo from '../../../../assets/images/logo.png'
import NavItem from './NavItem';
import { Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import { UserContext } from '../../../provider';

import ThemeModeToggler from '../../../ThemeModeToggler';
import Logout from '@mui/icons-material/Logout';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ListItemIcon from '@mui/material/ListItemIcon';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import { useNavigate } from 'react-router-dom';
import { COURSES_URL, LIBRARY_URL, LOGIN_URL } from '../../../../config/urls';


const Topbar = ({ onSidebarOpen, pages, colorInvert = false }) => {
  const {user, signOutUser} = useContext(UserContext);
  const theme = useTheme();
  const { mode } = theme.palette;
  const navigate = useNavigate();

  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const showLibrary = ()=>{
    navigate(LIBRARY_URL);
  }

  return (
    <Box
      display={'flex'}
      justifyContent={'space-between'}
      alignItems={'center'}
      width={1}
    >
      {/* --- Website Logo --- */}
      <Box
        display={'flex'}
        component="a"
        href="/"
        title="theFront"
        width={{ xs: 100, md: 150 }}
      >
        <Box
          component={'img'}
          src={
            mode === 'light' && !colorInvert
              ? logo
              : logo
          }
          height={1}
          width={1}
        />
      </Box>

      <Box display={'flex'}>
        {/* ---Nav menu --- */}
        <Box 
          sx={{ 
            display: { xs: 'none', md: 'flex' } 
          }} 
          alignItems={'center'}
        >
            <Box marginX={2}> 
              <NavItem
                linkTo={'/'}
                title={'Home'}
                colorInvert={colorInvert}
                style={{ textDecoration: 'none' }}
              />
            </Box>

            <Box marginX={2}> 
              <NavItem
                linkTo={COURSES_URL}
                title={'Tutorials'}
                colorInvert={colorInvert}
              />
            </Box>

            <Box marginLeft={2}> 
              <NavItem
                linkTo={'/about'}
                title={'About'}
                colorInvert={colorInvert}
              />
            </Box>
        </Box>
        

        {/* --- SideBar Button --- */}
        <Box sx={{ display: { xs: 'block', md: 'none' } }} alignItems={'center'}>
          <Button
            onClick={() => onSidebarOpen()}
            aria-label="Menu"
            variant={'outlined'}
            sx={{
              borderRadius: 2,
              minWidth: 'auto',
              padding: 1,
              borderColor: alpha(theme.palette.divider, 0.2),
            }}
          >
            <MenuIcon />
          </Button>
        </Box>

        <Box  
          display={'flex'}
          justifyContent={'space-between'}
          alignItems={'center'}
          marginLeft={2}
        >
          <ThemeModeToggler />

        </Box>

        {/* --- Account info --- */}
        {user?.email
          ? (
            <Box sx={{ flexGrow: 0 }} marginLeft={2}>
              <Tooltip title="Account">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar 
                    alt={user.name}
                    src={user.profilePicture}
                  />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {user?.email ?
                  (<Box>
                    <MenuItem >
                      <ListItemIcon>
                        <AccountCircleIcon/> 
                      </ListItemIcon>
                      <Typography> {user.email}</Typography>

                    </MenuItem>
                    <MenuItem onClick={showLibrary}>
                      <ListItemIcon>
                        <LibraryBooksIcon/> 
                      </ListItemIcon>
                      <Typography> Your Library</Typography>
                    </MenuItem>
                    <MenuItem onClick={signOutUser}>
                      <ListItemIcon>
                        <Logout fontSize="small" />
                      </ListItemIcon>
                      Logout
                    </MenuItem>
                  </Box>) :
                  (
                    <Box>
                      <Box 
                        component={'a'} 
                        href={LOGIN_URL}
                        colorInvert={colorInvert}
                        
                        style={{ textDecoration: 'none' }}
                      >
                      <MenuItem  >
                        <ListItemIcon>
                          <Logout fontSize="small" />
                        </ListItemIcon>
                        <Typography color={'text.primary'} fontWeight='600' fontSize={'1.2rem'}> Log in </Typography>
                      </MenuItem>
                      </Box>
                      {/* <MenuItem>
                        <CustomGoogleButton/>
                      </MenuItem> */}
                    </Box>
                  )
                }
              </Menu>
            </Box>
          )
          :(
            <Box>
          <Box 
            component={'a'} 
            href={LOGIN_URL}
            colorInvert={colorInvert}
          >
            <MenuItem 
              sx={{
                paddingX: '0.5rem',
                marginX: '0.5rem',
                borderRadius: '8px'
              }}
            >
              <Typography color={'text.primary'} fontWeight='600' fontSize={'1.2rem'}> Log in </Typography>
            </MenuItem>
          </Box>
        </Box>
          )
        }
        
      </Box>
    </Box>
  );
};

Topbar.propTypes = {
  onSidebarOpen: PropTypes.func,
  colorInvert: PropTypes.bool,
};

export default Topbar;
